import React from 'react';

import { SPAMMER_FLEXICON_RESOURCE } from './SpammerEntity';
import Flexicon from './shared/Flexicon';

const SpammerPopoverContent = ({ label, iconResource = SPAMMER_FLEXICON_RESOURCE }) => {
  return (
    <div className="flex w-50 flex-col items-stretch gap-5 px-3 pt-5 pb-5 font-medium">
      <div className="flex w-full min-w-0 flex-col items-center gap-2">
        <Flexicon resource={iconResource} size="size-14" />
        <div className="flex w-full min-w-0 flex-col items-center gap-0.5">
          <span className="block w-full truncate pb-0.5 text-center text-base leading-4 font-semibold text-white">{label}</span>
          <div className="text-center text-xs font-medium text-gray-400">All members were notified</div>
        </div>
      </div>
    </div>
  );
};

export default SpammerPopoverContent;
